import { showToast } from "../lib/toasts.mjs"
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="feed-item-link"
//
// Copies a deep link to this feed item (the current page URL + the item's #anchor) to the
// clipboard, so it can be pasted to point someone directly at this item in the feed.
// The anchor matches the id on the item's <turbo-frame> (e.g. "activity_13325043").
export default class extends Controller {
  static values = { anchor: String }

  copy(event) {
    event.preventDefault()
    event.stopPropagation()

    // Drop any existing query/hash so the link is just <origin><path>#<anchor>.
    const url = `${window.location.origin}${window.location.pathname}#${this.anchorValue}`

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url)
        .then(() => this.showToast())
        .catch(() => this.fallbackCopy(url))
    } else {
      this.fallbackCopy(url)
    }
  }

  fallbackCopy(text) {
    const textArea = document.createElement("textarea")
    textArea.value = text
    textArea.style.position = "fixed"
    textArea.style.left = "-999999px"
    textArea.style.top = "-999999px"
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      document.execCommand("copy")
      this.showToast()
    } catch (err) {
      // Copy failed silently
    }

    document.body.removeChild(textArea)
  }

  // Ink templates are present only on opted-in pages; retain existing feedback elsewhere.
  showToast() {
    if (showToast("Link copied to clipboard")) return

    const toast = document.createElement("div")
    toast.className = "z-50 fixed top-4 inset-x-0 w-fit mx-auto bg-support-dark-650 border border-solid border-support-dark-750 py-3 px-4 transition-opacity duration-1000 text-sm font-medium text-white rounded-2xl"
    toast.textContent = "Link copied to clipboard"
    document.body.appendChild(toast)

    setTimeout(() => {
      toast.classList.add("opacity-0")
      setTimeout(() => toast.remove(), 1000)
    }, 2000)
  }
}
